export const HTTP_BATCH_TIMEOUT = 5 * 60 * 1000;
